export default {
  LINKED_SOCIAL_ACCOUNTS_URL: "socialgrid/sources",
};
